// extracted by mini-css-extract-plugin
export default {"pageInfo":"PageInfoV3_pageInfo__oYwRb","header":"PageInfoV3_header__jEO4u","line":"PageInfoV3_line__biCUV","textBox":"PageInfoV3_textBox__90S1g","image":"PageInfoV3_image__EMJ1v"};